import { useEffect, useRef, useState } from 'react';
import Swal from 'sweetalert2';
import { getAllArticuloPrecio } from '../../../Services/articuloPrecioService';
import { getAllListasPrecios } from '../../../Services/listaPrecioService';

const usePagination = (history, isActive = true) => {
    let token = JSON.parse(atob(sessionStorage.getItem('token').split('.')[1]))
    let rol = token.authorities[0]

    const [isLoad, setIsLoad] = useState(true)
    const [articuloPrecios, setArticuloPrecios] = useState([])
    const [listaPrecios, setListaPrecios] = useState([]);
    const [listaPrecio, setListaPrecio] = useState({
        id: '',
        nombre: 'Seleccione una lista de precios'
    });

    //Pagination
    const [page, setPage] = useState(0)
    const [totalRegister, setTotalRegister] = useState(0)
    const [totalPage, setTotalPage] = useState(0)
    const [query, setQuery] = useState('')
    const [disabledExportButton, setDisabledExportButton] = useState(false)
    const lastSearchRef = useRef('')

    useEffect(() => {
        if (rol !== 'ROLE_ADMIN') history.goBack()
        if (isLoad) {
            getAllListasPrecios(true, 0, '', 1000)
                .then((res) => {
                    const listas = res.data.content
                    setListaPrecios(listas);

                    // Buscar si hay una lista seleccionada previamente en sessionStorage
                    const lastSelectedId = sessionStorage.getItem('lastSelectedListaPrecio')
                    const lastSelected = listas.find(l => l.id === Number(lastSelectedId))
                    if (lastSelected) {
                        setListaPrecio(lastSelected)
                    } else if (listas && listas.length > 0) {
                        setListaPrecio(listas[0])
                    }
                    setDisabledExportButton(res.data.content.length === 0)
                })
                .catch((err) => console.log('error get listas precios', err));
        } else {
            setIsLoad(false)
        }
    }, [history, isLoad, rol])

    // Cuando el usuario cambia de lista, guardar la selección en sessionStorage
    useEffect(() => {
        if (listaPrecio && listaPrecio.id) {
            sessionStorage.setItem('lastSelectedListaPrecio', listaPrecio.id)
            const searchValue = query.trim();
            getAllArticuloPrecio(isActive, 0, listaPrecio.id, searchValue)
                .then((res) => {
                    setPage(0)
                    setArticuloPrecios(res.data.content)
                    setTotalRegister(res.data.totalElements)
                    setTotalPage(res.data.totalPages)
                    setIsLoad(false)
                    setDisabledExportButton(res.data.content.length === 0)
                })
                .catch((err) => console.log('error'))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [listaPrecio, isActive])


    const nextPage = () => {
        if (totalPage === 0) {
            Swal.fire({
                toast: true,
                position: 'top',
                title: 'No hay mas páginas',
                type: 'info',
                showConfirmButton: false,
                timer: 1000,
            })
            return
        }
        if (page === totalPage - 1) {
            Swal.fire({
                toast: true,
                position: 'top',
                title: 'No hay mas páginas',
                type: 'info',
                showConfirmButton: false,
                timer: 1000,
            })
            return
        }
        getAllArticuloPrecio(isActive, page + 1, listaPrecio.id, query)
            .then((res) => {
                setPage(page + 1)
                setArticuloPrecios(res.data.content)
                setTotalRegister(res.data.totalElements)
                setTotalPage(res.data.totalPages)
                setIsLoad(false)
                setDisabledExportButton(res.data.content.length === 0)

            })
            .catch((err) => console.log('error'))
    }

    const previousPage = () => {
        if (page === 0) {
            Swal.fire({
                toast: true,
                position: 'top',
                title: 'No hay mas páginas',
                type: 'info',
                showConfirmButton: false,
                timer: 1000,
            })
            return
        }
        getAllArticuloPrecio(isActive, page - 1, listaPrecio.id, query)
            .then((res) => {
                setPage(page - 1)
                setArticuloPrecios(res.data.content)
                setTotalRegister(res.data.totalElements)
                setTotalPage(res.data.totalPages)
                setIsLoad(false)
                setDisabledExportButton(res.data.content.length === 0)

            })
            .catch((err) => console.log('error'))
    }

    const handleBuscador = (e) => {
        setQuery(e.target.value)

        if (e.key === 'Enter') {
            const trimmedValue = e.target.value.trim()

            // Si el input está vacío y había una búsqueda previa, se resetean todos los datos
            if (trimmedValue === '' && lastSearchRef.current !== '') {
                getAllArticuloPrecio(isActive, 0, listaPrecio.id, '')
                    .then((res) => {
                        setPage(0)
                        setArticuloPrecios(res.data.content)
                        setTotalRegister(res.data.totalElements)
                        setTotalPage(res.data.totalPages)
                        setIsLoad(false)
                        lastSearchRef.current = '' // Se actualiza la referencia al estado vacío
                        setDisabledExportButton(res.data.content.length === 0)
                    })
                    .catch((err) => console.log('error'))
            }
            // Si hay contenido y es diferente a la última búsqueda, hace una nueva búsqueda
            else if (trimmedValue !== '' && trimmedValue !== lastSearchRef.current) {
                getAllArticuloPrecio(isActive, 0, listaPrecio.id, trimmedValue)
                    .then((res) => {
                        setPage(0)
                        setArticuloPrecios(res.data.content)
                        setTotalRegister(res.data.totalElements)
                        setTotalPage(res.data.totalPages)
                        setIsLoad(false)
                        lastSearchRef.current = trimmedValue
                        setDisabledExportButton(res.data.content.length === 0)
                    })
                    .catch((err) => console.log('error'))
            }
        }
    }
    return {
        isLoad,
        articuloPrecios,
        listaPrecios,
        listaPrecio,
        setListaPrecio,
        page,
        totalRegister,
        totalPage,
        nextPage,
        previousPage,
        handleBuscador,
        setIsLoad,
        disabledExportButton
    }
}

export default usePagination
